import { Component } from '@angular/core';

import { NotificationService } from '../../../core/services/notification.service';
import { ConfigService } from '../../../core/services/config.service';
import { ActionClickEvent } from 'app/shared/components/dynamic-grid/dynamic-grid.component';
import { Subject } from 'rxjs';
import { EmployeeService } from 'app/organization/components/employees/employee.service';
import { SessionService } from '../../../core/services/session.service';

@Component({
  selector: 'itpx-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.css']
})
export class EmployeesComponent {
  private url: string;
  private detailsRoute: string = '/organization/users/{{key}}/details';
  private isUserAdmin: boolean;
  private isProdinEnv: boolean;
  private fields: Array<any> = [
    {
      title: 'First Name',
      name: 'firstName',
      config: {
        type: 'link',
        route: this.detailsRoute,
        key: 'id'
      }
    },
    {
      title: 'Last Name',
      name: 'lastName'
    },
    {
      title: 'Email',
      name: 'email'
    },
    {
      title: 'Roles',
      name: 'roles',
      config: {
        type: 'function'
      },
      function: (data: any) => {
        let roles = [];
        if (data.roles != null) {
          data.roles.forEach(role => roles.push(role.configValue))
        }
        return roles.join(', ');
      }

    }
  ];

  private refresh = new Subject<any>();
  isSellerAdmin: boolean;

  constructor(
    private configService: ConfigService,
    private service: EmployeeService,
    private notificationService: NotificationService,
    private sessionService: SessionService,
  ) {
    this.url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.employees.list.api;
    this.isProdinEnv = this.configService.get('envName') === 'prodin';
    let details = this.sessionService.getUserDetails();
    let groups = details && details['groups'] && details['groups'].length;
    this.isSellerAdmin = groups && details['groups'].find(_ => _ === 'seller-admin');
    this.isUserAdmin = this.service.checkIfUserIsAdmin();
  }

  private onActionClicked(e: ActionClickEvent) {
    if (e.action == 'invite') {
      this.service.invite(e.item).subscribe(body => {
        this.notificationService.success('Successfully invited the employee', 'Success');
        this.refresh.next(true);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/employees/employees.component.ts